import styled from "styled-components";

const Button = styled.button`
  padding: ${(props) => (props.large ? "1rem 2rem" : "0.8rem 1.5rem")};
  background: transparent;
  border: 1px solid ${(props) => props.theme.colors.accent};
  color: ${(props) => props.theme.colors.accent};
  font-family: "Playfair Display", serif;
  font-size: ${(props) => (props.large ? "1.2rem" : "1rem")};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${(props) => props.theme.colors.accent};
    color: ${(props) => props.theme.colors.primary};
  }
`;

export default Button;
